<template>
  <nav v-if="!loading">
    <ul
      class="pagination"
      v-if="moreThanOnePage"
    >
      <li
        class="page-item"
        v-if="!isInFirstPage"
      >
        <a
          class="page-link"
          @click="onClickFirstPage"
          href="#"
        >
          &laquo;
        </a>
      </li>
      <li
        class="page-item"
        :key="page.name"
        v-for="page in pages"
      >
        <a
          @click="!isPageActive(page.name)?onClickPage(page.name):''"
          class="page-link"
          href="#"
        >{{ page.name }}</a>
      </li>
      <li
        class="page-item"
        v-if="!isInLastPage"
      >
        <a
          class="page-link"
          @click="onClickLastPage"
          href="#"
        >
          &raquo;
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
    props: {
        maxVisibleButtons: {
            type: Number,
            required: false,
            default: 5
        },
        totalPages: {
            type: Number,
            required: true
        },
        currentPage: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        },
        targetScrollY: {
            type: String,
            required: false
        }
    },
    computed: {
        moreThanOnePage() {
            return this.totalPages > 1;
        },
        startPage() {
            // When on the first page
            if ( this.currentPage === 1 ) {
                return 1;
            }
            // When on the last page
            if ( this.currentPage === this.totalPages ) {
                return this.totalPages - this.maxVisibleButtons + 1;
            }
            // When in between
            return this.currentPage - 2;
        },
        pages() {
            const range = [];

            for ( let i = this.startPage;
                i <= Math.min( this.startPage + this.maxVisibleButtons - 1, this.totalPages );
                i += 1 ) {
                if ( i > 0 ) {
                    range.push( {
                        name: i,
                        isDisabled: i === this.currentPage
                    } );
                }
            }
            return range;
        },
        isInFirstPage() {
            return this.currentPage === 1;
        },
        isInLastPage() {
            return this.currentPage === this.totalPages;
        }
    },
    methods: {
        getOffsetTop( elem ) {
            let offsetTop = 0;
            do {
                if ( !isNaN( elem.offsetTop ) )
                {
                    offsetTop += elem.offsetTop;
                }
            } while ( elem === elem.offsetParent );
            return offsetTop;
        },
        scrollTop() {
            if ( typeof this.targetScrollY !== 'undefined' ) {
                let topPosition = document.getElementById( this.targetScrollY ).offsetTop;
                window.scrollTo( 0, topPosition );
            } else {
                window.scrollTo( 0, 0 );
            }
        },
        onClickFirstPage() {
            if ( this.currentPage > 1 ) {
                this.scrollTop();
                this.$emit( 'pagechanged', 1 );
            }
        },
        onClickPreviousPage() {
            if ( this.currentPage > 1 && this.currentPage <= this.totalPages ) {
                this.scrollTop();
                this.$emit( 'pagechanged', this.currentPage - 1 );
            }
        },
        onClickPage( page ) {
            this.scrollTop();
            this.$emit( 'pagechanged', page );
        },
        onClickNextPage() {
            this.scrollTop();
            if ( this.currentPage < this.totalPages ) {
                this.$emit( 'pagechanged', this.currentPage + 1 );
            }
        },
        onClickLastPage() {
            this.scrollTop();
            this.$emit( 'pagechanged', this.totalPages );
        },
        isPageActive( page ) {
            return this.currentPage === page;
        }
    }
};
</script>




// WEBPACK FOOTER //
// src/components/dashboard/clientanalytics/property/form/pagination.vue